import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6ff6421c&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./App.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "e372c40a"
  
)

component.options.__file = "App.vue"
export default component.exports